module.exports = __webpack_public_path__ + "static/img/double-seven-bc-pc.69e8f320.png";